import { IOrderExclusionsState } from './orderExclusionsState';
import { All as Actions } from './orderExclusionsActions';
import { OrderExclusionContants } from './orderExclusionConstants';

const initialState: IOrderExclusionsState = {
  errorMessage: null,
  isLoading: false,
  orderExclusions: [],
};

export function orderExclusions(
  state = initialState,
  action: Actions
): IOrderExclusionsState {
  switch (action.type) {
    case OrderExclusionContants.GET_ORDER_EXCLUSIONS_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case OrderExclusionContants.GET_ORDER_EXCLUSIONS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        orderExclusions: action.orderExclusions,
      };
    }
    case OrderExclusionContants.GET_ORDER_EXCLUSIONS_FAILURE: {
      return {
        ...state,
        isLoading: false,
        errorMessage: action.error,
      };
    }
    default:
      return state;
  }
}
